import { render } from "./HomeVideo.vue?vue&type=template&id=48c43e38&scoped=true"
import script from "./HomeVideo.vue?vue&type=script&lang=js"
export * from "./HomeVideo.vue?vue&type=script&lang=js"

import "./HomeVideo.vue?vue&type=style&index=0&id=48c43e38&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c43e38"]])

export default __exports__